import { Component, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

import { LayoutService } from '@core/service/layout.service';
import { CoreModule } from '@core/core.module';

import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { ConviviaLogoComponent } from '../convivia-logo/convivia-logo.component';
import { TenantSwitcherComponent } from '../tenant-switcher/tenant-switcher.component';
import { AuthService } from 'zenith/auth';
import { NotificationInboxComponent } from '../notification-inbox/notification-inbox.component';

@Component({
  selector: '[app-topbar]',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  imports: [
    BreadcrumbComponent,
    CoreModule,
    FormsModule,
    StyleClassModule,
    InputTextModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    RippleModule,
    BadgeModule,
    OverlayBadgeModule,
    AvatarModule,
    ToggleSwitchModule,
    ConviviaLogoComponent,
    TenantSwitcherComponent,
    NotificationInboxComponent,
  ],
})
export class TopbarComponent {
  protected readonly isInactive = computed(
    () =>
      this.layoutService.layoutState().staticMenuDesktopInactive &&
      this.layoutService.layoutConfig().menuMode === 'static'
  );
  protected readonly isReveal = computed(() => this.layoutService.layoutConfig().menuMode === 'reveal');
  protected readonly isOverlay = computed(() => this.layoutService.layoutConfig().menuMode === 'overlay');

  constructor(
    private readonly layoutService: LayoutService,
    private readonly authService: AuthService
  ) {}

  protected onMenuButtonClick(): void {
    this.layoutService.onMenuToggle();
  }

  protected onConfigButtonClick(): void {
    this.layoutService.layoutState.update(prev => ({ ...prev, configSidebarVisible: !prev.configSidebarVisible }));
  }

  protected getCurrentUser(): string | undefined {
    return 'Hola, ' + this.authService.getCurrentUser()?.getFirstName();
  }

  protected logout(): void {
    this.authService.clearAuth();
  }
}
